import BudgetDemand from './budget-demand';

export default BudgetDemand;
